const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div>
      <div role="alert" className="mx-auto max-w-max">
        There was an error:{" "}
        <pre style={{ whiteSpace: "normal" }}>{error.message}</pre>
        <button
          type="button"
          onClick={resetErrorBoundary}
          className="flex items-center px-7 py-3 bg-artfulRed text-white rounded-md mb-5"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
